export const PERSIAN_MONTHS = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
] as const;

export const getPersianMonthName = (monthIndex: number): string =>
  PERSIAN_MONTHS[monthIndex];

export const PERSIAN_WEEK_DAYS = [
  'یکشنبه',
  'دوشنبه',
  'سه‌شنبه',
  'چهارشنبه',
  'پنجشنبه',
  'جمعه',
  'شنبه',
] as const;

export const getPersianWeekName = (dayIndex: number): string =>
  PERSIAN_WEEK_DAYS[dayIndex];
